<!-- BrowserUsage.vue -->
<script setup lang="ts">
import { ref } from 'vue';
import { DoughnutChart } from 'vue-chart-3';
import { Chart, registerables } from 'chart.js';

// Register Chart.js components
Chart.register(...registerables);

// Chart data
const chartData = ref({
  labels: ['Firefox', 'Safari', 'Chrome', 'IE'],
  datasets: [
    {
      backgroundColor: ['#41B883', '#FFC107', '#00D8FF', '#DD1B16'], // amber -> #FFC107 (amber color)
      data: [40, 20, 80, 10]
    }
  ]
});

// Chart options
const chartOptions = ref({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top' as const,
      fullWidth: true,
      labels: {
        fontSize: 16,
        fontStyle: 'bold' as const
      }
    },
    title: {
      display: true,
      text: 'Browser Usage',
      position: 'bottom' as const,
      fontSize: 20,
      fontStyle: 'bold' as const
    }
  }
});

// If you need to update chart data dynamically
const updateChart = (newData: number[]) => {
  chartData.value = {
    ...chartData.value,
    datasets: [
      {
        ...chartData.value.datasets[0],
        data: newData
      }
    ]
  };
};

// Expose methods if needed
defineExpose({
  updateChart
});
</script>

<template>
  <DoughnutChart :chart-data="chartData" :options="chartOptions" />
</template>